import useInitInjectScripts from 'components/ThirdPartyScripts/hooks/useInitInjectScripts';
import TrialModalView from 'components/Trials/ModalView';
import TrialPageView from 'components/Trials/PageView';
import BusinessInfoContextProvider from 'contexts/BusinessContextProvider';
import NotificationContextProvider from 'contexts/NotificationContextProvider';
import TrialsContextProvider, {
  useTrialsContext,
} from 'contexts/TrialsContextProvider';
import useMobileViewport from 'hooks/useMobileViewport';

import { TrialsGlobalStyles } from './styles';

import TrialRoiView from 'components/Trials/RoiView';

const TrialsPage = () => {
  useInitInjectScripts(true);
  useMobileViewport();
  const { isRearrangeStepsFlow, showMultiStep, isRoiFlow } =
    useTrialsContext() || {};

  return isRearrangeStepsFlow || showMultiStep ? (
    <TrialPageView />
  ) : isRoiFlow ? (
    <TrialRoiView />
  ) : (
    <TrialModalView />
  );
};

const Trials = () => (
  <TrialsContextProvider>
    <BusinessInfoContextProvider>
      <TrialsGlobalStyles />
      <NotificationContextProvider>
        <TrialsPage />
      </NotificationContextProvider>
    </BusinessInfoContextProvider>
  </TrialsContextProvider>
);

export default Trials;
